import { primitives } from 'styles/colors'

export type ColorName = keyof typeof primitives

// Primitive values for inline styles, style objects and SVG attributes. These can't
// use var(--…): PostCSS replaces primitive properties with their values at build
// time, so none exist in the page.
export const color = (name: ColorName): string => primitives[name]

export const CHART_SERIES: readonly string[] = [
  color('chart-1'),
  color('chart-2'),
  color('chart-3'),
  color('chart-4'),
  color('chart-5'),
  color('chart-6'),
  color('chart-7'),
  color('chart-8')
]

// The "everything else" bucket after a chart's named series.
export const CHART_OTHER = color('neutral-300')
